module.exports = {"621125100":"武阳镇","621125101":"三岔镇","621125102":"新寺镇","621125103":"金钟镇","621125104":"盐井镇","621125105":"殪虎桥镇","621125106":"大草滩镇","621125107":"四族镇","621125108":"石川镇","621125109":"贵清山镇","621125204":"马泉乡","621125208":"武当乡","621125209":"东泉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621125.json
// module id = 2739
// module chunks = 0